import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import api from '~/services/api';

import { successInRequest, failedRequest } from './actions';

export function* requestVtCertificados({ payload }) {
    try {
        const { params } = payload;
        const response = yield call(api.get, 'vagaotanque', {
            params,
            paramsSerializer: (param) => qs.stringify(param),
        });

        const { items, page, pageSize, totalCount, totalPages } = response.data;

        yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
    } catch (erros) {
        yield put(failedRequest());
        erros.map((error) => toast.error(error));
    }
}

export function* applyedFilters({ payload }) {
    try {
        const { params } = payload;

        const response = yield call(api.get, 'vagaotanque', {
            params,
            paramsSerializer: (param) => qs.stringify(param),
        });

        const { items, page, pageSize, totalCount, totalPages } = response.data;
        yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
    } catch (erros) {
        yield put(failedRequest());
        erros.map((error) => toast.error(error));
    }
}

export default all([
    takeLatest('@vtcertificados/VTCERTIFICADOS_IN_REQUEST', requestVtCertificados),
    takeLatest('@vtcertificados/SUCCESS_REMOVE', requestVtCertificados),
    takeLatest('@vtcertificados/RECORD_FILTERING', applyedFilters),
]);
